/**
 * Copyright (c) 2026 Stefan Radig
 *
 * Which URLs a page may load or navigate to. URLs often come from shared
 * documents (a Drive item, a plugin's data), and a javascript: or data: URL
 * loaded into a page or the shell's app frame would run in Editoor's origin.
 */

const NAVIGABLE_SCHEMES = ['http:', 'https:'];

/**
 * Whether `url` may be loaded: relative to `baseHref` (app pages) or absolute,
 * http or https only. The URL parser normalises case, whitespace and control
 * characters first, so "Java\tScript:" is refused like "javascript:".
 */
export function isNavigableUrl(url: string | null | undefined, baseHref: string): boolean {
    if (!url) return false;
    try {
        return NAVIGABLE_SCHEMES.includes(new URL(url, baseHref).protocol);
    } catch {
        return false;
    }
}
